module.exports = __webpack_public_path__ + "assets/img/1435.84802b29.svg";